import React from 'react';
import ConversationIndexCard from './conversation_index_card';
import { removeDuplicates } from '../utils/messenger_utils';
import PropTypes from 'prop-types';

const ConversationIndex = ({
  indexList,
  handleNewConversationWindow,
  handleTotalUnreadCount,
  handleConversationList,
  searchInput
}) => {
  const searchInProgress = searchInput.length > 2;

  const showBoolean = (conversation) =>
    searchInProgress
      ? conversation.orderedNames
          .join(' ')
          .toLowerCase()
          .includes(searchInput.toLowerCase())
      : true;

  const noResults = indexList.every((convo) => showBoolean(convo) == false);

  if (searchInProgress && noResults) {
    return <p className="text-center w3 mt-10">No results.</p>;
  }

  if (indexList.length == 0) {
    return <p className="text-center w3 mt-10">No conversations.</p>;
  }

  const index = removeDuplicates(indexList).map((conversation) => (
    <ConversationIndexCard
      key={conversation.id}
      id={conversation.id}
      unreadMessageCount={conversation.unreadMessageCount}
      orderedNames={conversation.orderedNames}
      day={conversation.day}
      mostRecentMessage={conversation.mostRecentMessage}
      avatars={conversation.avatars}
      conversation={conversation}
      handleNewConversationWindow={handleNewConversationWindow}
      handleTotalUnreadCount={handleTotalUnreadCount}
      handleConversationList={handleConversationList}
      show={showBoolean(conversation)}
    />
  ));

  return index;
};

ConversationIndex.propTypes = {
  indexList: PropTypes.array.isRequired,
  handleNewConversationWindow: PropTypes.func.isRequired,
  handleTotalUnreadCount: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired
};

export default ConversationIndex;
